import React from "react";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import { Box, Button, Chip, Stack, Typography } from "@mui/material";
import colors from "../../assets/theme/colors";

const ImportHistoryReviewFileList = ({ groups, drafts, reviewedSourceIds, selectedSourceId, onSelect }) => (
  <Stack spacing={1} aria-label="Imported files">
    {groups.map((group) => {
      const groupDrafts = drafts.filter((draft) => draft.sourceNoteId === group.sourceNoteId);
      const missingDateCount = groupDrafts.filter((draft) => !draft.localDate).length;
      const reviewed = reviewedSourceIds.has(group.sourceNoteId);
      const selected = selectedSourceId === group.sourceNoteId;
      return (
        <Button
          key={group.sourceNoteId}
          aria-current={selected ? "true" : undefined}
          onClick={() => onSelect(group.sourceNoteId)}
          sx={{
            p: 1.4,
            border: "1px solid",
            borderColor: selected ? colors.semantic.sage : colors.semantic.line2,
            borderRadius: 2.25,
            bgcolor: selected ? colors.semantic.sageMist : "background.paper",
            color: colors.semantic.ink,
            justifyContent: "flex-start",
            textAlign: "left",
            textTransform: "none",
          }}
        >
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography noWrap sx={{ fontSize: "0.9rem", fontWeight: 900 }}>{group.fileName}</Typography>
            <Typography sx={{ mt: 0.15, color: colors.semantic.ink2, fontSize: "0.76rem" }}>
              {group.candidates.length} {group.candidates.length === 1 ? "entry" : "entries"}
            </Typography>
            <Stack direction="row" spacing={0.6} sx={{ mt: 0.65 }}>
              {reviewed ? <Chip label="Reviewed" size="small" sx={{ height: 21, bgcolor: colors.semantic.sageSoft, color: colors.semantic.sageDeep, fontWeight: 800, fontSize: "0.68rem" }} /> : null}
              {missingDateCount ? <Chip label={`${missingDateCount} ${missingDateCount === 1 ? "needs" : "need"} a date`} size="small" sx={{ height: 21, bgcolor: "#FFF0DB", color: "#9A5A13", fontWeight: 800, fontSize: "0.68rem" }} /> : null}
            </Stack>
          </Box>
          <ChevronRightRoundedIcon sx={{ color: colors.semantic.ink3 }} />
        </Button>
      );
    })}
  </Stack>
);

export default ImportHistoryReviewFileList;
